import { trigger, transition, style, animate } from '@angular/animations';

export const fadeInUpAnimation = trigger('fadeInUp', [
  transition(':enter', [
    style({ 
      opacity: 0, 
      transform: 'translateY(15px)' 
    }),
    animate('0.6s {{ delay }}ms ease-out', 
      style({ 
        opacity: 1, 
        transform: 'translateY(0)' 
      })
    )
  ], { params: { delay: 0 } })
]);

